import * as React from "react";
import i18n from "i18n";
import { useTranslation } from "react-i18next";
import { Badge } from "components/bootstrap";
import NavBadgeItem from "components/navigation/NavBadgeItem";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import HealthRoutes from "./Routes";
import { getStatusLabel, STATUS_BADGE_COLORS, STATUS_ICONS } from "./healthStatusCopy";
import { PROBLEM_STATUSES } from "./healthTree";
import { useHealthSummary } from "./useHealthModule";
import useHealthModuleVisible from "./useHealthModuleVisible";
const formatProblemBreakdown = (counts) => PROBLEM_STATUSES.filter((status) => counts[status] > 0).map((status) => i18n.t(`health.badge.breakdown.${status}`, { ns: "enterprise_license", count: counts[status] })).join(", ");
const HealthStatusBadge = () => {
  const { t } = useTranslation("enterprise_license");
  const showHealthModule = useHealthModuleVisible();
  const { error, isLoading, overallStatus, problemCount, statusCounts, totalCheckCount } = useHealthSummary();
  const sendTelemetry = useSendTelemetry("cluster-health");
  if (!showHealthModule) return null;
  const displayStatus = error ? "unknown" : overallStatus;
  const showProblemCount = !error && !isLoading && problemCount > 0;
  const checks = t("health.badge.checks", { count: totalCheckCount });
  let healthLabel = showProblemCount ? t("health.badge.problems", {
    status: getStatusLabel(overallStatus),
    breakdown: formatProblemBreakdown(statusCounts),
    checks
  }) : t("health.badge.all_passing", { status: getStatusLabel(overallStatus), checks });
  if (isLoading) {
    healthLabel = t("health.badge.loading");
  }
  if (error) {
    healthLabel = t("health.badge.unavailable", { message: error.message });
  }
  return /* @__PURE__ */ React.createElement(
    NavBadgeItem,
    {
      to: HealthRoutes.OVERVIEW,
      onClick: () => sendTelemetry(TELEMETRY_EVENT_TYPE.CLUSTER_HEALTH.BADGE_CLICKED, {
        event_details: { status: displayStatus, problem_count: showProblemCount ? problemCount : 0 }
      })
    },
    /* @__PURE__ */ React.createElement(
      Badge,
      {
        "aria-label": healthLabel,
        color: STATUS_BADGE_COLORS[displayStatus],
        "data-testid": "health-status-badge",
        leftIcon: STATUS_ICONS[displayStatus],
        title: healthLabel
      },
      showProblemCount ? problemCount : null
    )
  );
};
export default HealthStatusBadge;
